<template>
	<div class="official-recommend-page" data-build="video-poster-lazy-v3-20260707">
		<div class="content-container">
			<div class="menuBox">
				<div class="menuItem">
					<div class="menuTitle">
						资产
					</div>
					<el-radio-group v-model="type" @input="changeCateType">
						<el-radio :label="2">资源整合专区</el-radio>
						<el-radio :label="1">2D3D数字材质</el-radio>
					</el-radio-group>
				</div>
				<div class="menuItem">
					<div class="menuTitle">
						{{`${type == 1 ? '材质' : '模型'}类别` }}
					</div>
					<el-radio-group v-model="cid" @input="currentPage = 1;getGoodsList()">
						<el-radio :label="item.id" v-for="(item,index) in classifyData"
							:key="index">{{item.title}}</el-radio>
					</el-radio-group>
				</div>
				<div class="menuItem">
					<div class="menuTitle">
						排列方式
					</div>
					<el-radio-group v-model="sort" @input="currentPage = 1;getGoodsList()">
						<el-radio :label="item.key" v-for="(item,index) in sortOpts"
							:key="index">{{item.title}}</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="content-container-right">
				<div class="filterSearchBox">
					<div class="filterBox" @click="userMenuShow = true">
						<img class="filterImg" src="../assets/Register/filter.png" />
					</div>
					<div class="searchBox">
						<img class="searchIcon" src="../assets/Register/searchIcon.png" />
						<input type="text" v-model="keywords" placeholder="可以根据作品名称、作品关键字标签模糊搜索" class="inputBox"
							@blur="searchKeywords" />
						<input ref="imageSearchInput" class="imageSearchInput" type="file" accept="image/*"
							@change="onImageSearchFileChange" />
						<button class="imageSearchBtn" :class="{ loading: imageSearchLoading }" type="button"
							@click.stop="triggerImageSearch">
							{{ imageSearchLoading ? '识别中' : '以图搜图' }}
						</button>
					</div>
				</div>
				<div class="videoBannerGrid">
					<div class="videoBannerItem" v-for="item in videoBanners" :key="item.id" @click="openBannerVideo(item)"
						@mouseenter="playBannerVideo($event, item)" @mouseleave="pauseBannerVideo">
						<video class="videoBanner" :data-src="item.src" :poster="item.poster" muted loop playsinline
							preload="none"></video>
						<div class="videoBannerHint">PLAY {{ item.id }}</div>
					</div>
				</div>
				<div class="orderListBox">
					<div class="orderList" v-if="worksData.length">
						<div class="orderItem" v-for="(item,index) in worksData" :key="index"
							@click="curGoods = item;workDetailsShow = true">
							<img class="orderImg" :src="item.img" />
							<div class="orderName">{{item.title}}</div>
							<div class="exchange">
								<div class="num">兑换量：{{item.buy_count}}</div>
								<div>兑换积分：{{item.original_price}}</div>
							</div>
						</div>
					</div>
				</div>
				<PagePagination style="padding: .6rem 0 .6rem;" :currentPage="currentPage" :pageSize="24" :total="total"
					@current-change="onPageChange" />
			</div>
		</div>
		<WorkDetailsDialog :show="workDetailsShow" :isBuy="curGoods.is_buy" :goodsId="curGoods.id"
			@close="workDetailsShow = false" />
		<el-drawer class="drawerMenu" :visible.sync="userMenuShow" direction="ltr" size="60%" :show-close="false">
			<div class="drawerMenuBox">
				<div class="menuItem">
					<div class="menuTitle">
						资产
					</div>
					<el-radio-group v-model="type" @input="changeCateType">
						<el-radio :label="2">资源整合专区</el-radio>
						<el-radio :label="1">2D3D数字材质</el-radio>
					</el-radio-group>
				</div>
				<div class="menuItem">
					<div class="menuTitle">
						{{`${type == 1 ? '材质' : '模型'}类别` }}
					</div>
					<el-radio-group v-model="cid" @input="currentPage = 1;getGoodsList()">
						<el-radio :label="item.id" v-for="(item,index) in classifyData"
							:key="index">{{item.title}}</el-radio>
					</el-radio-group>
				</div>
				<div class="menuItem">
					<div class="menuTitle">
						排列方式
					</div>
					<el-radio-group v-model="sort" @input="currentPage = 1;getGoodsList()">
						<el-radio :label="item.key" v-for="(item,index) in sortOpts"
							:key="index">{{item.title}}</el-radio>
					</el-radio-group>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import axios from 'axios'
	import WorkDetailsDialog from '../components/WorkDetailsDialog.vue'
	export default {
		name: 'WorksList',
		components: {
			WorkDetailsDialog
		},
		data() {
			return {
				userMenuShow: false,
				classifyData: [],
				worksData: [],
				banner: [],
				videoBanners: [1, 2, 3, 4, 5, 6].map(item => ({
					id: item,
					src: `/video/banner${item}.mp4`,
					poster: `/video/banner${item}.jpg`,
				})),
				workDetailsShow: false,
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				sortOpts: [{
					title: '默认排序',
					key: 'default',
					value: 0,
				}, {
					title: '免费资源',
					key: 'mf_status',
					value: 1,
				}, {
					title: '最多兑换',
					key: 'px_buy',
					value: 1,
				}, {
					title: '积分升序',
					key: 'px_price_sx',
					value: 1,
				}, {
					title: '积分降序',
					key: 'px_price_jx',
					value: 2,
				}],
				sucPop: false,
				curGoods: {},
				goodsId: '',
				keywords: '',
				sort: 'default',
				type: 1,
				cid: 0,
				imageSearchLoading: false,
				imageSearchMode: false,
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.type = this.$route.query.type * 1
			}
			this.changeCateType(this.type)
		},
		methods: {
			playBannerVideo(event, item) {
				const video = event.currentTarget && event.currentTarget.querySelector('video')
				if (!video) return
				if (!video.getAttribute('src') && item && item.src) {
					video.setAttribute('src', item.src)
					video.load()
				}
				video.play().catch(() => {})
			},
			pauseBannerVideo(event) {
				const video = event.currentTarget && event.currentTarget.querySelector('video')
				if (!video) return
				video.pause()
			},
			openBannerVideo(item) {
				if (!item || !item.src) return
				window.open(item.src, '_blank')
			},
			//跳转Banner详情
			naviToBannerDetails(item) {
				if (!item.mb_id) return
				window.open(item.mb_id, '_blank');
			},
			//获取轮播图
			getBanner() {
				this.$api.post('/Other/banner', {}).then(res => {
					if (res.code == 1) {
						this.banner = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			onPageChange(newPage) {
				if (this.imageSearchMode) return
				this.currentPage = newPage
				this.getGoodsList()
			},
			searchKeywords() {
				this.currentPage = 1
				this.getGoodsList()
			},
			triggerImageSearch() {
				if (this.imageSearchLoading) return
				if (this.$refs.imageSearchInput) {
					this.$refs.imageSearchInput.click()
				}
			},
			onImageSearchFileChange(event) {
				const file = event.target.files && event.target.files[0]
				event.target.value = ''
				if (!file) return
				this.searchByImage(file)
			},
			searchByImage(file) {
				this.imageSearchLoading = true
				const formData = new FormData()
				formData.append('file', file)
				formData.append('top_k', '24')
				axios.post('https://xieke.cc/api/materials/search_image', formData).then(res => {
					const body = res.data || {}
					if (body.code !== 200) {
						throw new Error(body.msg || '以图搜图失败')
					}
					const list = body.data && body.data.materials ? body.data.materials : []
					this.currentPage = 1
					this.imageSearchMode = true
					this.worksData = list.map(item => this.normalizeVisualMaterial(item))
					this.total = this.worksData.length
					this.$message.success(`以图搜图完成，找到 ${this.total} 个相似结果`)
				}).catch(err => {
					console.log(err)
					this.$message.error((err && err.message) || '以图搜图失败，请稍后再试')
				}).finally(() => {
					this.imageSearchLoading = false
				})
			},
			parseMaterialTags(tags) {
				const result = {}
				if (!tags || typeof tags !== 'string') return result
				tags.split(';').forEach(part => {
					const index = part.indexOf(':')
					if (index > 0) {
						result[part.slice(0, index)] = part.slice(index + 1)
					}
				})
				return result
			},
			normalizeVisualMaterial(item) {
				const tags = this.parseMaterialTags(item.tags)
				const goodsId = tags.old_gz_goods_id || tags.old_goods_id || item.goods_id || item.old_goods_id || item.id
				const imageUrl = item.thumb_url || item.preview_url || item.img || item.image || ''
				const price = item.cost_points !== undefined ? item.cost_points : (tags.old_buy_price || item.original_price || 0)
				return {
					...item,
					id: goodsId,
					material_id: item.id,
					img: imageUrl,
					title: item.title || item.name || '',
					buy_count: item.buy_count || 0,
					original_price: price,
					is_buy: item.is_buy || 0,
					top_title: item.top_title || '材质',
				}
			},
			getGoodsList() {
				this.imageSearchMode = false
				this.$api.post('/Goods/goods_list', {
					pagesize: 24,
					type: this.type,
					p: this.currentPage,
					title: this.keywords,
					cid: this.cid == 0 ? '' : this.cid,
					mf_status: this.sort == 'mf_status' ? 1 : '',
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
					px_price: this.sort == 'px_price_sx' ? 1 : this.sort == 'px_price_jx' ? 2 : '',
					px_buy: this.sort == 'px_buy' ? 1 : '',
				}).then(res => {
					if (res.code == 1) {
						this.worksData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeCateType(event) {
				this.currentPage = 1
				this.keywords = ''
				this.sort = 'default'
				this.cid = 0
				this.imageSearchMode = false
				this.getGoodsList()
				this.$api.post('/Other/classify_list', {
					type: event,
				}).then(res => {
					if (res.code == 1) {
						this.classifyData = [{
							id: 0,
							title: '全部'
						}, ...res.data]
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.imageSearchInput {
		display: none;
	}

	.searchBox {
		.inputBox {
			flex: 1;
			min-width: 0;
		}
	}

	.imageSearchBtn {
		flex: 0 0 .9rem;
		height: .28rem;
		border: none;
		border-radius: .04rem;
		background: #98E83E;
		font-size: .13rem;
		font-weight: 500;
		color: #252525;
		cursor: pointer;
		white-space: nowrap;

		&.loading {
			opacity: .72;
			cursor: wait;
		}
	}

	.carousel-image {
		width: 100%;
		height: 2rem;
		object-fit: cover;
		cursor: pointer;
	}

	.videoBannerGrid {
		width: 100%;
		margin-top: .24rem;
		display: grid;
		grid-template-columns: repeat(6, minmax(0, 1fr));
		gap: .12rem;
	}

	.videoBannerItem {
		position: relative;
		height: 2rem;
		border-radius: .08rem;
		overflow: hidden;
		background: #111;
		border: .01rem solid rgba(255, 255, 255, .08);
		cursor: pointer;
	}

	.videoBanner {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.videoBannerHint {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		height: .3rem;
		padding: 0 .18rem;
		border-radius: .15rem;
		background: rgba(152, 232, 62, .9);
		color: #111;
		font-size: .13rem;
		font-weight: 600;
		line-height: .3rem;
		pointer-events: none;
	}

	.videoBannerItem:hover .videoBannerHint {
		opacity: 0;
	}

	::v-deep .el-carousel__button {
		width: .3rem;
	}

	::v-deep .el-carousel__indicator {
		margin-bottom: 0 !important;
	}

	@media (min-width: 1921px) {
		.content-container {
			margin: .06rem auto 0;
			width: 17.18rem;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
		}

		.menuBox {
			width: 1.52rem;
			display: flex;
			flex-direction: column;
			border-bottom: .01rem solid rgba(44, 44, 44, 1);

			.menuItem {
				display: flex;
				flex-direction: column;
				padding: .24rem 0 .24rem .24rem;
				border-top: .01rem solid rgba(44, 44, 44, 1);
				border-left: .01rem solid rgba(44, 44, 44, 1);
				border-right: .01rem solid rgba(44, 44, 44, 1);

				.menuTitle {
					margin-bottom: .08rem;
					font-size: .14rem;
					color: #C8C8C8;
					line-height: .2rem;
				}
			}
		}

		.content-container-right {
			width: 15.42rem;
			display: flex;
			flex-direction: column;

			.filterSearchBox {
				display: flex;
				align-items: center;
				justify-content: flex-end;

				.filterBox {
					display: none;
				}

				.searchBox {
					width: 5.44rem;
					height: .34rem;
					padding: 0 .08rem;
					border: .01rem solid #2C2C2C;
					display: flex;
					align-items: center;

					.searchIcon {
						width: .16rem;
						height: .16rem;
					}

					input {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 15.42rem;

			.orderList {
				display: flex;
				flex-wrap: wrap;
				width: 100%;

				.orderItem:nth-child(6n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .4rem;
					margin-right: .18rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 2.42rem;
						height: 2.42rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .28rem;
						width: 2.42rem;
						font-weight: 500;
						font-size: .18rem;
						color: #FFFFFF;
						line-height: .25rem;
					}

					.exchange {
						margin-top: .12rem;
						width: 2.42rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #B9B9BB;
						line-height: .2rem;

						.num {
							width: 1rem;
						}
					}
				}
			}
		}


		.inputBox {
			width: 100%;
			height: 0.34rem;
			border: none;
			padding: 0 0.12rem;
			font-size: 0.14rem;
			color: #FFFFFF;
			line-height: .34rem;
			outline: none;
			transition: border-color 0.3s ease;
			background: none;

			&::placeholder {
				color: rgba(200, 200, 200, .6);
			}
		}

		::v-deep .el-radio-group {
			display: flex;
			flex-direction: column;

			.el-radio {
				line-height: .2rem;

				.el-radio__label {
					padding-left: 0;
					margin-left: .12rem;
					font-size: .14rem;
					line-height: .2rem;
					color: rgba(200, 200, 200, 1) !important;
				}

				.el-radio__input {
					line-height: .2rem;

					.el-radio__inner {
						width: .14rem;
						height: .14rem;
						border: .01rem solid rgba(124, 124, 124, 1);
						background: rgba(44, 44, 44, 1);

						&::after {
							width: .04rem;
							height: .04rem;
							background: rgba(44, 44, 44, 1);
						}

						&:hover {
							border-color: rgba(152, 232, 62, 1);
						}
					}
				}

				.is-checked {
					background: rgba(44, 44, 44, 1);

					.el-radio__inner {
						border-color: rgba(152, 232, 62, 1);
						background: rgba(152, 232, 62, 1);
					}
				}
			}
		}
	}

	@media (max-width: 480px) {
		.content-container {
			margin: .06rem auto 0;
			width: 12rem;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
		}

		.menuBox {
			display: none;
		}

		.drawerMenuBox {
			width: 6.08rem;
			display: flex;
			flex-direction: column;
			border-bottom: .01rem solid rgba(44, 44, 44, 1);

			.menuItem {
				display: flex;
				flex-direction: column;
				padding: .24rem 0 .24rem .24rem;
				border-top: .01rem solid rgba(44, 44, 44, 1);
				border-left: .01rem solid rgba(44, 44, 44, 1);
				border-right: .01rem solid rgba(44, 44, 44, 1);

				.menuTitle {
					margin-bottom: .64rem;
					font-size: .56rem;
					color: #C8C8C8;
					line-height: .8rem;
				}
			}
		}

		.content-container-right {
			width: 12rem;
			display: flex;
			flex-direction: column;

			.filterSearchBox {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.filterBox {
					margin-right: .24rem;
					height: 1.02rem;
					width: 1.02rem;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: .12rem;
					border: 0.01rem solid #393939;

					.filterImg {
						height: .4rem;
						width: .4rem;
					}
				}

				.searchBox {
					width: 10rem;
					height: 1.02rem;
					padding: 0 .24rem;
					border: .01rem solid #2C2C2C;
					display: flex;
					align-items: center;

					.searchIcon {
						width: .48rem;
						height: .48rem;
					}

					.inputBox {
						width: 100%;
						height: 1rem;
						border: none;
						padding: 0 0.12rem;
						font-weight: 400;
						font-size: .42rem;
						color: #FFFFFF;
						line-height: .68rem;
						outline: none;
						transition: border-color 0.3s ease;
						background: none;

						&::placeholder {
							color: rgba(200, 200, 200, .6);
						}
					}

					.imageSearchBtn {
						flex-basis: 1.72rem;
						height: .72rem;
						border-radius: .1rem;
						font-size: .32rem;
					}
				}
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 12rem;

			.orderList {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.orderItem:nth-child(2n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .8rem;
					margin-right: .48rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 5.64rem;
						height: 5.64rem;
						border-radius: .16rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .56rem;
						width: 5.64rem;
						font-weight: 500;
						font-size: .36rem;
						color: #FFFFFF;
						line-height: .5rem;
					}

					.exchange {
						margin-top: .24rem;
						width: 4.84rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .28rem;
						color: #B9B9BB;
						line-height: .4rem;
					}

					.num {
						width: 2rem;
					}
				}
			}
		}

		::v-deep .el-radio-group {
			display: flex;
			flex-direction: column;

			.el-radio {
				line-height: .8rem;

				.el-radio__label {
					padding-left: 0;
					margin-left: .48rem;
					font-size: .56rem;
					line-height: .8rem;
					color: rgba(200, 200, 200, 1) !important;
				}

				.el-radio__input {
					line-height: .8rem;

					.el-radio__inner {
						width: .56rem;
						height: .56rem;
						border: .01rem solid rgba(124, 124, 124, 1);
						background: rgba(44, 44, 44, 1);

						&::after {
							width: .16rem;
							height: .16rem;
							background: rgba(44, 44, 44, 1);
						}

						&:hover {
							border-color: rgba(152, 232, 62, 1);
						}
					}
				}

				.is-checked {
					background: rgba(44, 44, 44, 1);

					.el-radio__inner {
						border-color: rgba(152, 232, 62, 1);
						background: rgba(152, 232, 62, 1);
					}
				}
			}
		}
	}

	@media (min-width: 481px) and (max-width: 1920px) {
		.content-container {
			margin: .06rem auto 0;
			width: 12rem;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
		}

		.menuBox {
			width: 1.52rem;
			display: flex;
			flex-direction: column;
			border-bottom: .01rem solid rgba(44, 44, 44, 1);

			.menuItem {
				display: flex;
				flex-direction: column;
				padding: .24rem 0 .24rem .24rem;
				border-top: .01rem solid rgba(44, 44, 44, 1);
				border-left: .01rem solid rgba(44, 44, 44, 1);
				border-right: .01rem solid rgba(44, 44, 44, 1);

				.menuTitle {
					margin-bottom: .08rem;
					font-size: .14rem;
					color: #C8C8C8;
					line-height: .2rem;
				}
			}
		}

		.content-container-right {
			width: 10.24rem;
			display: flex;
			flex-direction: column;

			.filterSearchBox {
				display: flex;
				align-items: center;
				justify-content: flex-end;

				.filterBox {
					display: none;
				}

				.searchBox {
					width: 5.44rem;
					height: .34rem;
					padding: 0 .08rem;
					border: .01rem solid #2C2C2C;
					display: flex;
					align-items: center;

					.searchIcon {
						width: .16rem;
						height: .16rem;
					}

					input {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 10.24rem;

			.orderList {
				display: flex;
				flex-wrap: wrap;
				width: 100%;

				.orderItem:nth-child(4n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .4rem;
					margin-right: .18rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 2.42rem;
						height: 2.42rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .28rem;
						width: 2.42rem;
						font-weight: 500;
						font-size: .18rem;
						color: #FFFFFF;
						line-height: .25rem;
					}

					.exchange {
						margin-top: .12rem;
						width: 2.42rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #B9B9BB;
						line-height: .2rem;

						.num {
							width: 1rem;
						}
					}
				}
			}
		}


		.inputBox {
			width: 100%;
			height: 0.34rem;
			border: none;
			padding: 0 0.12rem;
			font-size: 0.14rem;
			color: #FFFFFF;
			line-height: .34rem;
			outline: none;
			transition: border-color 0.3s ease;
			background: none;

			&::placeholder {
				color: rgba(200, 200, 200, .6);
			}
		}

		::v-deep .el-radio-group {
			display: flex;
			flex-direction: column;

			.el-radio {
				line-height: .2rem;

				.el-radio__label {
					padding-left: 0;
					margin-left: .12rem;
					font-size: .14rem;
					line-height: .2rem;
					color: rgba(200, 200, 200, 1) !important;
				}

				.el-radio__input {
					line-height: .2rem;

					.el-radio__inner {
						width: .14rem;
						height: .14rem;
						border: .01rem solid rgba(124, 124, 124, 1);
						background: rgba(44, 44, 44, 1);

						&::after {
							width: .04rem;
							height: .04rem;
							background: rgba(44, 44, 44, 1);
						}

						&:hover {
							border-color: rgba(152, 232, 62, 1);
						}
					}
				}

				.is-checked {
					background: rgba(44, 44, 44, 1);

					.el-radio__inner {
						border-color: rgba(152, 232, 62, 1);
						background: rgba(152, 232, 62, 1);
					}
				}
			}
		}
	}


	.drawerMenu {

		::v-deep .el-drawer {
			&__container {
				.el-drawer {
					background: rgba(8, 8, 8, 1);
				}
			}
		}
	}

	.official-recommend-page .filterSearchBox .searchBox {
		box-sizing: border-box;
		flex-wrap: nowrap;
		overflow: hidden;
	}

	.official-recommend-page .filterSearchBox .searchBox .inputBox {
		flex: 1 1 auto !important;
		width: auto !important;
		min-width: 0 !important;
	}

	.official-recommend-page .filterSearchBox .searchBox .imageSearchBtn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 .9rem !important;
		width: .9rem !important;
		min-width: .9rem !important;
		max-width: .9rem !important;
		height: .28rem !important;
		margin-left: .08rem;
		padding: 0 !important;
		border: none;
		border-radius: .04rem !important;
		line-height: .28rem !important;
		font-size: .13rem !important;
	}

	@media (max-width: 480px) {
		.videoBannerGrid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: .18rem;
		}

		.videoBannerItem {
			height: 2.1rem;
			border-radius: .12rem;
		}
	}
</style>
